import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { Warehouse } from '../../models/storage/warehouse';


@Injectable({
  providedIn: 'root'
})
export class WarehouseService {

  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }


  public getWarehouses(includeInactive: boolean = false): Observable<Warehouse[]> {

    let queryParameters = new HttpParams();

    queryParameters.append('includeInactive', includeInactive.toString());

    return this.httpClient.get<Warehouse[]>(`${this.basePath}/api/warehouses`);
  }

  public putWarehouse(warehouse: Warehouse, isERPSave: boolean = false): Observable<Warehouse[]> {
    return this.httpClient.put<Warehouse[]>(`${this.basePath}/api/warehouses/${warehouse.id}?saveERPFlag=${isERPSave}`, warehouse);
  }

  public getWarehouse(id: number): Observable<Warehouse> {
    return this.httpClient.get<Warehouse>(`${this.basePath}/api/warehouses/${id}`);
  }

  public deleteWarehouse(id: number, isERPSave: boolean = false) {
    return this.httpClient.delete(`${this.basePath}/api/warehouses/${id}?saveERPFlag=${isERPSave}`);
  }

  public postWarehouse(warehouse: Warehouse, isERPSave: boolean = false): Observable<Warehouse> {
    return this.httpClient.post<Warehouse>(`${this.basePath}/api/warehouses?saveERPFlag=${isERPSave}`, warehouse);
  }
}
